/* eslint-disable @typescript-eslint/no-unused-vars */

export default function useMockTimeFrequency({ submenu }: {
  submenu: string;
}) {
  const data = [
    { label: 'Horário', value: 'h' },
    { label: 'Diário', value: 'd' },
    { label: 'Mensal', value: 'm' },
  ];

  const error = undefined;

  return { data, error };
}
